import React from 'react'

const Error = () => {
  return (
    <div className='flex items-center justify-center min-h-[calc(100vh-500px) text-3xl text-white'>
      Error - 404 Not Found</div>
  )
}

export default Error